import * as types from './actionType';

/**
 * Creates Action Type For API_ERROR
 * @constructor
 * @param {Object} error;
 * @returns Action Type For API_ERROR
 */
export function apiErrorAction(error) {
    return {
        type: types.API_ERROR,
        error,
    };
}
